/**
 * @description: 艺人列表
 * @author: hwx
 */
<template>
	<div class="waiter-list-wrap">
        <div class="waiter-list" v-show="showList">
            <h1>艺人列表</h1>
            <el-form :inline="true" :model="list_form">
				<el-form-item label="门店">
					<el-select v-model="list_form.shop_id" clearable filterable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="组别">
					<el-input v-model="list_form.group_name" class="el-ellipsis" clearable placeholder="请选择组别" @focus="enterGroup" @clear="groupDeal"></el-input>
				</el-form-item>
                <el-form-item class="wait-complex">
					<el-input placeholder="请输入查找内容" v-model="list_form.search_value">
						<el-select v-model="list_form.search_key" slot="prepend">
							<el-option label="艺名" value="stage_name"></el-option>
							<el-option label="腰牌号" value="waist_tag"></el-option>
						</el-select>
					</el-input>
				</el-form-item>
				<el-form-item class="pull-right">
					<a href="https://vodonline.g-hi.com/Download/personnelInfoImportTemplate.xls" class="el-button el-button--primary">艺人资料模板下载</a>
					<el-button type="primary" @click="xlsYrImport">艺人资料模板导入</el-button>
					<input type="file" @change="uploadYrXlsFile($event)" ref="yrXlsFile" id="yrXlsFile" class="input-file-hide el-button">
					<a href="https://vodonline.oss-cn-beijing.aliyuncs.com/Download/personnelImportTemplate.xls" class="el-button el-button--primary">串台次数模板下载</a>
					<el-button type="primary" @click="xlsImport">串台次数模板导入</el-button>
                    <input type="file" @change="uploadXlsFile($event)" ref="waitXlsFile" id="waitXlsFile" class="input-file-hide el-button">
					<el-button type="primary" @click="listQuery">查询</el-button>
					<el-button @click="exportList">导出</el-button>
				</el-form-item>
			</el-form>
            <el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="list_table">
				<el-table-column prop="shop_name" label="门店"></el-table-column>
				<el-table-column prop="group_name" label="组别"></el-table-column>
				<el-table-column prop="director_name" label="主管"></el-table-column>
				<el-table-column prop="stage_name" label="艺名"></el-table-column>
				<el-table-column prop="waist_tag" label="腰牌号"></el-table-column>
				<el-table-column prop="mobile" label="手机号"></el-table-column>
				<el-table-column prop="ct_allow_num" label="串台次数"></el-table-column>
				<el-table-column prop="balance" label="台费余额"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="waitDel(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="list_page"
				:total="list_total"
				@current-change="getListTable">
			</el-pagination>
        </div>
        <!-- 组别列表 -->
        <div class="page-group" v-show="showGroup">
            <h2>请选择组别</h2>
            <div class="page-group-search pull-right">
                <el-input placeholder="请输入组别名称" v-model="group_name"></el-input>
                <img src="../../assets/images/group_search.png" @click="groupList">
            </div>
            <!-- 列表 -->
            <div class="page-group-list">
                <el-checkbox :indeterminate="group_sign" v-model="group_all" @change="groupAll">全选</el-checkbox>
				<el-checkbox-group v-model="group_ids" @change="groupChange">
					<el-checkbox v-for="item in group_list" :key="item.group_id" :label="item.group_id">{{item.group_name}}</el-checkbox>
				</el-checkbox-group>
            </div>
            <div class="page-group-btns">
                <el-button @click="groupBack">返回</el-button>
                <el-button type="primary" @click="groupSub">确定</el-button>
            </div>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				showGroup: false,
				loading: false,
                shop_list: [],

				list_form: {
                    shop_id: '',
                    group_name: '',
                    search_key: 'stage_name',
                    search_value: '',
				},
				list_page: 1,
				list_total: 0,
				list_table: [],

				group_sign: false,
				group_all: false,
				group_name: '',
				group_ids: [],
				c_group_ids: [],
				group_list: [],
			}
		},
        created: function() {
			this.getShop();
		},
		mounted: function() {
			
		},
		methods: {
			// 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
						_this.list_form.shop_id = _this.shop_list[0].id;
						_this.getListTable(1);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
            },

            // 列表
			getListTable: function(page) {
				const _this = this;

				_this.loading = true;
				_this.list_page = page;
				Vue.axios.post('Personnel/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"shop_id": _this.list_form.shop_id,
                            "group_id": _this.group_ids,
                            "search_key": _this.list_form.search_key,
                            "search_value": _this.list_form.search_value
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count);
						}
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			listQuery() {
				this.getListTable(1);
			},
			// 进入选择组别
            enterGroup() {
				this.c_group_ids = this.group_ids;
                this.groupList();
				this.showList = false;
				this.showGroup = true;
			},
			// 清空组别
			groupDeal() {
				this.group_all = false;
				this.group_sign = false;
				this.group_ids = [];
			},
			// 全选
			groupAll(val) {
				const _this = this;
				let ids = [];
				_this.group_list.forEach(v => {
					ids.push(v.group_id);
				});
				_this.group_ids = val ? ids : [];
				_this.group_sign = false;
			},
			// 选中
			groupChange(val) {
				let count = val.length;
				this.group_all = count === this.group_list.length;
				this.group_sign = count > 0 && count < this.group_list.length;
			},
			// 返回
            groupBack: function() {
				this.group_ids = this.c_group_ids;
            	this.showList = true;
				this.showGroup = false;
			},
			// 确定组别
			groupSub() {
				const _this = this;
                let arr = [];
                _this.group_list.forEach(function(item) {
                    _this.group_ids.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.list_form.group_name = arr.join(',');
				this.showList = true;
				this.showGroup = false;
			},
			// 获取组别
			groupList() {
				const _this = this;

				Vue.axios.post('FinanceReport/getGroupSearchList', {
					"header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": _this.list_form.shop_id,
                            "key_word": 'personnel',
                            "group_name": _this.group_name
                        }
                    },
                    "comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.group_list = res.data.response.result;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 删除
			waitDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Personnel/delete', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getListTable(_this.list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},
			// 导入
			xlsImport: function() {
				this.$refs.waitXlsFile.click();
			},
			// 上传
			uploadXlsFile: function(e) {
				const _this = this;

				let formData = new FormData();
				let obj = document.getElementById('waitXlsFile');
				formData.append("personnelFile", obj.files[0]);
				// 清除file
				obj.value = '';

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.list_form.shop_id,
						}
					},
					"comment": ""
				};
				Vue.axios.post("Personnel/import?shop_id=" + _this.list_form.shop_id, formData, {
					transformRequest: [function(data, headers) {
						// 覆盖默认
						return data;
					}]
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('导入成功');
						_this.getListTable(_this.list_page);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 导入
			xlsYrImport: function() {
				this.$refs.yrXlsFile.click();
			},
			// 上传
			uploadYrXlsFile: function(e) {
				const _this = this;

				let formData = new FormData();
				let obj = document.getElementById('yrXlsFile');
				formData.append("personnelDataFile", obj.files[0]);
				// 清除file
				obj.value = '';

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.list_form.shop_id,
						}
					},
					"comment": ""
				};
				Vue.axios.post("Personnel/importPersonnelData?shop_id=" + _this.list_form.shop_id, formData, {
					transformRequest: [function(data, headers) {
						// 覆盖默认
						return data;
					}]
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('导入成功');
						_this.getListTable(_this.list_page);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 导出
            exportList() {
                window.location.href = Vue.ctUrl + "Personnel/exportList" +
                    "?shop_id=" + this.list_form.shop_id +
                    "&group_id=" + this.group_ids +
                    "&search_key=" + this.list_form.search_key +
                    "&search_value=" + this.list_form.search_value
                layer.msg("导出成功！")
            },

        }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.waiter-list {
		.wait-complex {
			.el-select {
				width: 100px;
			}
		}
	}
	.page-group {
        .page-group-search {
            position: relative;
            margin: 0 0 20px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
        }
        .page-group-list {
			clear: both;
			margin: 0 0 30px;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>